var React = require('react');

function Pipe (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4353_7023)","key":0},React.createElement("path",{"d":"M21.784 28.0703H15.5982C11.8636 28.0703 8.83593 24.8935 8.83593 20.975V10.8336C8.83593 9.85164 8.07684 9.05516 7.14101 9.05516H2.02148M2.02148 1.73486V5.61693V9.499M21.784 21.1513V28.9154M15.9401 15.4148H8.54041M2.02148 2.4675H8.83593C12.7262 2.58426 15.4331 5.56829 15.4331 9.38956V20.3761C15.4331 21.2303 16.0937 21.9234 16.9078 21.9234H21.784","stroke":"#FD4E03","strokeWidth":"2.54818","strokeMiterlimit":"10","strokeLinecap":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4353_7023"},React.createElement("rect",{"width":"23.0562","height":"30.5781","fill":"white","transform":"translate(0.375 0.0361328)"})))]);
}

Pipe.defaultProps = {"width":"24","height":"31","viewBox":"0 0 24 31","fill":"none"};

module.exports = Pipe;

Pipe.default = Pipe;
